import { render, staticRenderFns } from "./WriteSvg.vue?vue&type=template&id=4ef2914d&"
var script = {}
import style0 from "./WriteSvg.vue?vue&type=style&index=0&id=4ef2914d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports